module.exports = __webpack_public_path__ + "img/clock.88160ad6.svg";